import React, { useState, useRef, useEffect } from 'react';
import * as S from './CalendarInput.style';

const CalendarInput = ({ value, onChange, placeholder = '날짜 선택' }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedDate, setSelectedDate] = useState(
		value ? new Date(value) : new Date(),
	);
	const calendarRef = useRef(null);

	// 바깥 클릭 시 달력 닫기
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (calendarRef.current && !calendarRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const formatDate = (date) => {
		if (!date) return '';
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	const handleDateSelect = (date) => {
		setSelectedDate(date);
		setIsOpen(false);
		if (onChange) {
			onChange(formatDate(date));
		}
	};

	const getDaysInMonth = (year, month) => {
		return new Date(year, month + 1, 0).getDate();
	};

	const getFirstDayOfMonth = (year, month) => {
		return new Date(year, month, 1).getDay();
	};

	const generateCalendarDays = () => {
		const year = selectedDate.getFullYear();
		const month = selectedDate.getMonth();
		const daysInMonth = getDaysInMonth(year, month);
		const firstDay = getFirstDayOfMonth(year, month);

		const days = [];

		// 이전 달의 빈 칸들
		for (let i = 0; i < firstDay; i++) {
			days.push(null);
		}

		// 현재 달의 날짜들
		for (let day = 1; day <= daysInMonth; day++) {
			days.push(new Date(year, month, day));
		}

		return days;
	};

	const goToPreviousMonth = () => {
		setSelectedDate(
			new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1),
		);
	};

	const goToNextMonth = () => {
		setSelectedDate(
			new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1),
		);
	};

	const monthNames = [
		'1월',
		'2월',
		'3월',
		'4월',
		'5월',
		'6월',
		'7월',
		'8월',
		'9월',
		'10월',
		'11월',
		'12월',
	];

	const dayNames = ['일', '월', '화', '수', '목', '금', '토'];

	return (
		<S.Container ref={calendarRef}>
			<S.InputButton onClick={() => setIsOpen(!isOpen)}>
				{value ? formatDate(new Date(value)) : placeholder}
			</S.InputButton>

			{isOpen && (
				<S.Calendar>
					<S.CalendarHeader>
						<S.NavButton onClick={goToPreviousMonth}>‹</S.NavButton>
						<S.MonthYear>
							{selectedDate.getFullYear()}년{' '}
							{monthNames[selectedDate.getMonth()]}
						</S.MonthYear>
						<S.NavButton onClick={goToNextMonth}>›</S.NavButton>
					</S.CalendarHeader>

					<S.CalendarBody>
						<S.DayNames>
							{dayNames.map((day) => (
								<S.DayName key={day}>{day}</S.DayName>
							))}
						</S.DayNames>

						<S.DaysGrid>
							{generateCalendarDays().map((day, index) =>
								day ? (
									<S.Day
										key={index}
										onClick={() => handleDateSelect(day)}
										isSelected={value && formatDate(day) === value}>
										{day.getDate()}
									</S.Day>
								) : (
									<S.EmptyDay key={index} />
								),
							)}
						</S.DaysGrid>
					</S.CalendarBody>
				</S.Calendar>
			)}
		</S.Container>
	);
};

export default CalendarInput;
